import React from 'react';
import PropTypes from 'prop-types';

import { Stack } from '@metarouter-private/mr-mui';

import { INTEGRATION_TYPES } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/buildTableData';

import OpenPlaybookButton from './OpenPlaybookButton';
import GatedOpenEventDebuggerButton from './GatedOpenEventDebuggerButton';

export default function LinkActions({ type, integration, playbookId }) {
  if (type === INTEGRATION_TYPES.UNMANAGED) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <OpenPlaybookButton integration={integration} playbookId={playbookId} />
      <GatedOpenEventDebuggerButton integration={integration} />
    </Stack>
  );
}

LinkActions.propTypes = {
  type: PropTypes.oneOf(Object.values(INTEGRATION_TYPES)).isRequired,
  integration: PropTypes.object.isRequired,
  playbookId: PropTypes.string,
};
